/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from "react";
import { activityCommonDefaultProps, activityCommonPropTypes } from "../shared";
import { useTheme } from "../../../../reducers/layoutReducer/selectors";

const ActivityContainer = ({ activity, children, onReadChange, queryParams }) => {
  const isPlace = useTheme().name === "place-theme";
  const [mouseDownTag, setMouseDownTag] = useState(false);

  return (
    <div
      onClick={async () => {
        if (!activity.read) {
          await onReadChange();
        }
        if (activity.personUuid) {
          window.location.href = `/${activity.data?.notableType === "Listing" ? "transactions" : "people"}/${activity.data?.notableId || activity.personUuid}${queryParams ? `?${queryParams}` : ""}`;
        }
      }}
      role="link"
      tabIndex={0}
      className={`tw-text-brand-primary hover:tw-text-brand-primary tw-group tw-border-solid tw-border-[1px] tw-rounded-[16px] tw-w-full tw-bg-white tw-pt-12px tw-pl-12px tw-pr-24px tw-pb-24px tw-flex tw-flex-col tw-gap-16px


      hover:tw-no-underline tw-border-gray-10 tw-shadow-[0px_2px_8px_0px_rgba(213,213,213,0.5)]
      ${activity.personUuid ? "tw-cursor-pointer" : "tw-cursor-default"}
      ${isPlace ? "hover:tw-border-[#C8D9FA]" : "hover:tw-border-[#DEF3F3]"}
      ${mouseDownTag ? `${isPlace ? "active:tw-shadow-[0_0_0_3px_#C8D9FA]" : "active:tw-shadow-[0_0_0_3px_#DEF3F3]"} active:tw-no-underline` : ""}
      `}
      onMouseDown={() => setMouseDownTag(true)}
      onMouseUp={() => setMouseDownTag(false)}
    >
      {children}
    </div>
  );
};

export default ActivityContainer;

ActivityContainer.propTypes = {
  ...activityCommonPropTypes,
};

ActivityContainer.defaultProps = {
  ...activityCommonDefaultProps,
};
